<template>
  <div :class="isMobile ? 'about-m' : 'about'">
    <div class="word">
      <div class="word-title">关于我们</div>
      <div class="word-text">About Us</div>
    </div>
    <div class="content">
      <div class="contentText">
        <div class="title">
          艾感科技(广东)有限公司
        </div>
        <div class="content-p">
          艾感科技是一家成立于2018年的国家高新技术企业、专精特新中小企业，专注于仿生嗅觉芯片和气体传感器的设计、研发、生产。总部位于佛山，并在深圳、香港设有研发中心，公司市场估值超２亿。
        </div>
        <div class="content-p">
          研发团队荟聚了博士、教授、行业专家等高科技复合型人才。其中，联合创始人范智勇教授在纳米基材、气敏材料和芯片器件结构领域，有20多年的产品研发与应用创新能力积累，为国内外认可的行业领军人物。他带领团队不断突破技术壁垒，创新研发出了纳米蜂巢（NHC）第三代半导体气体传感器技术。
        </div>
        <div class="content-p">
          该技术攻克了传统传感领域“体积大、成本高、混合气味识别不准”的行业痛点。利用该技术研发的新一代“小型化人工电子鼻模组”，具备低功耗、长寿命、高精度、高灵敏度、高稳定、易于大规模集成等优势，产线成本仅为传统技术的10％。
        </div>
        <div class="content-p">
          目前，艾感科技已构建从芯片到应用的全场景解决方案，并在具身智能、康复养老、工业环保、智能家居、智慧出行、食品安全等多个领域实现商业化落地。未来，我们将持续巩固专利壁垒，向智慧医疗、元宇宙市场演进，打造具有国际影响力的中国传感品牌。
        </div>
      </div>
    </div>

      <div class="ability-box">
        <el-row :gutter="isMobile?0:30">
          <el-col :span="isMobile?24:8" v-for="(item, index) in abilitylist" :key="index">
            <div class="gray-box">
              <div class="ability-tit">
                <span class="blue-text"  v-number-scroll="item.num">{{ item["blue-title"] }}</span>
                {{ item.title }}
              </div>
              <div class="ability-text">{{ item.text }}</div>
            </div>
          </el-col>
        </el-row>
      </div>

      <img src="./../../assets/about/about-big.png" class="middle-bg" />

      <div>
        <div class="word">
          <div class="word-title">技术实力</div>
          <div class="word-text">Technical Strength</div>
        </div>
      </div>
      <div class="tech-box">
        <div class="tech-title">纳米蜂巢（NHC）第三代半导体工艺</div>
        <div class="tech-subtitle">——全球首创的仿生嗅觉芯片技术</div>
        <div class="tech-detail">艾感科技独创的纳米蜂巢（NHC）第三代半导体工艺，通过构建三维多孔纳米立体结构与N×N交叉电极检测网络，形成蜂巢状纳米孔洞阵列，极大提升了比表面积（指数级提升单位面积的气敏材料附着量），可实现混合气体与复杂气味的实时分析，支持多单元并行采集，突破了传统气体传感器的性能瓶颈，推动气体传感从“单一检测”迈向“仿生智能”时代，为气体传感领域带来了新的发展方向和应用前景。</div>
        <img src="./../../assets/icon/tech-big.png" class="tech-big" />
        <el-row :gutter="isMobile?10:30">
          <el-col :span="isMobile?12:6" v-for="(item, index) in technologylist" :key="index">
            <div class="tech-one">
              <img :src="item.url" class="tech-one-img" />
              <div class="tech-one-title">{{ item.title }}</div>
              <div class="tech-one-con">{{ item.content }}</div>
            </div>
          </el-col>
        </el-row>
      </div>


    <div class="middle-text">
      <div class="middle-text-tit">
        赋能千行百业
      </div>
      <div class="middle-text-con">
        面向未来，艾感科技始终以用户需求为核心，开展气体成分检测和分析的嗅觉芯片技术研发，力求以“芯”的生命力，赋能产业终端应用，创造更加智能美好的未来。
      </div>
    </div>

    <div class="content">
      <div class="contentlist">
        <el-row>
          <el-col :span="12" v-for="(item, index) in aboutlist.slice(0,2)" :key="index">
            <div class="content-one">
              <div class="content-one-num">
                <span v-number-scroll="item.num" class="aigan-right-content-num" >
                  0
                </span>{{ item.unit }}
              </div>
              <div class="content-one-dec">{{ item.dec }}</div>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8" v-for="(item, index) in aboutlist.slice(2)" :key="index">
            <div class="content-one" >
              <div class="content-one-num">
                <span v-number-scroll="item.num" class="aigan-right-content-num" >
                  0
                </span>{{ item.unit }}
              </div>
              <div class="content-one-dec">{{ item.dec }}</div>
            </div>
          </el-col>
        </el-row>
        
      </div>
    </div>

    <div class="develop">
      <div class="word">
        <div class="word-title">发展历程</div>
        <div class="word-text">Development History</div>
      </div>
      <div class="timelist">
        <el-row>
          <el-col :span="8">
            <div v-for="(one,i) in timelist" :key="i" class="timelist-year-one" @click="goTo(i)">
              <div class="timelist-line"></div>
              <div class="timelist-text">
                <span :class="currentYear==i ? 'timelist-year blueFont':'timelist-year'">{{ one.year }}</span>
                <span :class="currentYear==i ? 'timelist-bot timelist-blueBot-big' : 'timelist-bot'"></span>
              </div>
            </div>
          </el-col>
          <el-col :span="16">
            <el-carousel :height="isMobile?'7rem':'400px'" direction="vertical" 
                        :autoplay="false" ref="carousel" indicator-position="none">
              <el-carousel-item v-for="(one,i) in timelist" :key="i">
                <div class="timelist-content">
                  <div v-for="(item,index) in one.text" :key="index" class="timelist-content-one">
                    <span class="idot"></span>
                    <span>{{item}}</span>
                  </div>
                  <img :src="one.url" class="timelist-content-year" />
                </div>
              </el-carousel-item>
            </el-carousel>
          </el-col>
        </el-row>
      </div>
    </div>

    <div class="mission word">
      <div class="word-title">企业文化</div>
      <div class="word-text">Corporate Culture</div>
      <div class="mission-content">
        <el-row :gutter="isMobile? 0:60">
          <el-col :span="isMobile ? 24 : 8">
            <div class="mission-one">
              <div class="one-sort">01</div>
              <div class="one-title">VALUE</div>
              <div class="one-title-cn">价值观</div>
              <div class="one-text">客户第一，奋斗为本，追求卓越</div>
            </div>
          </el-col>
          <el-col :span="isMobile ? 24 : 8">
            <div class="mission-one">
              <div class="one-sort">02</div>
              <div class="one-title">MISSION</div>
              <div class="one-title-cn">使命</div>
              <div class="one-text">做世界上最好的嗅觉传感器</div>
            </div>
          </el-col>
          <el-col :span="isMobile ? 24 : 8">
            <div class="mission-one">
              <div class="one-sort">03</div>
              <div class="one-title">VISION</div>
              <div class="one-title-cn">愿景</div>
              <div class="one-text">赋予机器嗅觉感知世界</div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>

    <div>
        <div class="word">
          <div class="word-title">科研成果</div>
          <div class="word-text">Research Achievements</div>
        </div>
      </div>
      <div class="intel-box">
        <el-row>
          <el-col :span="6" v-for="(item, index) in intelList_01" :key="item.text" class="intel-one" >
            <div class="intel-one-con">
              <span class="intel-one-num" v-number-scroll="item.num" >1</span>
              <span class="intel-one-unit">{{ item.unit }}</span>
            </div>
            <div class="intel-one-text">
              {{ item.text }}
            </div>
          </el-col>
          <el-col :span="8" v-for="(item, index) in intelList_02" :key="item.text" class="intel-one" >
            <div class="intel-one-con">
              <span class="intel-one-num" v-number-scroll="item.num" >1</span>
              <span class="intel-one-unit">{{ item.unit }}</span>
            </div>
            <div class="intel-one-text">
              {{ item.text }}
            </div>
          </el-col>
        </el-row>
      </div>

      <div class="intellectual">
        <div class="word">
          <div class="word-title">知识产权</div>
          <div class="word-text">Intellectual Property</div>
        </div>
        <div class="intellectual-content">
          <div class="bannerList">
            <div class="bannerList">
              <div class="intelswiper swiper">
                <div class="swiper-wrapper">
                  <div class="swiper-slide" v-for="(item, i) in intellectualList" :key="i">
                    <div class="swipperItem">
                      <img style="width: 100%;height: 100%;" :src="item.url" />
                      <div class="img-up-word">
                        <div class="img-up-word-content">{{item.title}}</div>
                        <!-- <div class="img-up-word-dec">{{item.date}}</div> -->
                      </div>
                    </div></div>
                </div>
                <div class="swiper-button-prev intel_prev"></div>
                <div class="swiper-button-next intel_next" ></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="intellectual">
        <div class="word">
          <div class="word-title">荣誉证书</div>
          <div class="word-text">Certificate of Honor</div>
        </div>
        <div class="intellectual-content">
          <div class="bannerList">
            <div class="bannerList">
              <div class="honorswiper swiper">
                <div class="swiper-wrapper">
                  <div class="swiper-slide" v-for="(item, i) in honorlist" :key="i">
                    <div class="swipperItem">
                      <img style="width: 100%;height: 100%;" :src="item.url" />
                      <div class="img-up-word">
                        <div class="img-up-word-content">{{item.title}}</div>
                        <!-- <div class="img-up-word-dec">{{item.date}}</div> -->
                      </div>
                    </div></div>
                </div>
                <div class="swiper-button-prev honor_prev"></div>
                <div class="swiper-button-next honor_next" ></div>
              </div>
            </div>
          </div>
        </div>
      </div>

    <div class="cooperation">
      <div class="word">
        <div class="word-title">合作伙伴</div>
        <div class="word-text">Partners</div>
      </div>
      <div>
        <div class="cooswiper01 swiper">
          <div class="swiper-wrapper">
            <div class="swiper-slide" v-for="(item, i) in partnerlist[0].list" :key="i">
              <div class="swipperOne">
                <div class="swipperItem">
                  <img class="coo-img" :src="item" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
      <div class="cooperation2">
        <div class="cooswiper02 swiper">
          <div class="swiper-wrapper">
            <div class="swiper-slide" v-for="(item, i) in partnerlist[1].list" :key="i">
              <div class="swipperOne">
                <div class="swipperItem">
                  <img class="coo-img" :src="item" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="cooperation cooperation3">
        <div class="cooswiper03 swiper">
          <div class="swiper-wrapper">
            <div class="swiper-slide" v-for="(item, i) in partnerlist[2].list" :key="i">
              <div class="swipperOne">
                <div class="swipperItem">
                  <img class="coo-img" :src="item" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    
  </div>
</template>

<script>
  import imgUrl from "@/utils/imgUrl"
  import arrJson from '@/utils/arrJson'
  import "leaflet/dist/leaflet.css";
  import { createNumberScrollDirective } from '@/utils/VueNumberScroll.js';
  import Swiper from "swiper";
  import "swiper/swiper.min.css"

  export default {
    name: 'About',
    directives: {
    'number-scroll': createNumberScrollDirective({
      duration: 1600,
      easing: 'easeOut',
      separator: ',',
      once: false
    })
  },
    data() {
      return {
        imgUrl,
        isMobile: window.innerWidth < 780,
        username: "",
        userphone: "",
        userText: "",
        aboutlist: arrJson.aboutlist,
        partnerlist: arrJson.partnerlist,
        abilitylist: arrJson.abilitylist,
        technologylist: arrJson.technologylist,
        intelList_01: [
          {
            num: 81,
            unit: "件",
            text: "发明专利"
          }, {
            num: 39,
            unit: "件",
            text: "授权专利"
          },{
            num: 28,
            unit: "项",
            text: "商标"
          }, {
            num: 11,
            unit: "项",
            text: "软著"
          }
        ],
        intelList_02: [{
            num: 2,
            unit: "件",
            text: "外观专利"
          },{
            num: 2,
            unit: "件",
            text: "国际专利(PCT)"
          },{
            num: 5,
            unit: "件",
            text: "实用新型"
          }
        ],
        intellectualList: arrJson.intellectualList,
        honorlist: arrJson.honorList,
        timelist: arrJson.companyTimelist.reverse(),
        currentYear: 0
      }
    },
    props: {
      msg: String
    },
    mounted() {
      window.addEventListener("resize", this.initFunc)
      this.setSwiper()
    },
    destroyed() {
      window.removeEventListener("resize", this.initFunc)
    },

    methods: {
      initFunc() {
        this.isMobile = window.innerWidth < 780
      },
      setSwiper(){
        const t = this
        this.swiper1 = new Swiper('.cooswiper01', {
          loop: true, // 是否循环，内容会两倍
          autoplay: {
            delay: 0,  // 切换间隔时间（毫秒）
            disableOnInteraction: false,  // 用户操作后是否停止自动播放
          },
          speed: 4000,
          clickable: true,
          slidesPerView: t.isMobile ? 3 : 5,
        })
        this.swiper2 = new Swiper('.cooswiper02', {
          loop: true, // 是否循环，内容会两倍
          autoplay: {
            delay: 0,
            reverseDirection: true, // 反向播放
          }, // 是否自动播放
          speed: 4000,
          clickable: true,
          slidesPerView: t.isMobile ? 4 : 6,
        })
        this.swiper3 = new Swiper('.cooswiper03', {
          loop: true, // 是否循环，内容会两倍
          autoplay: {
            delay: 0,
          }, // 是否自动播放
          speed: 4000,
          clickable: true,
          slidesPerView: t.isMobile ? 3 : 5,
        })
        this.swiper1 = new Swiper('.intelswiper', {
          // pagination: {
          //   el: '.swiper-pagination-intellectual',
          //   clickable: true,
          // },
          // loop: true, // 是否循环，内容会两倍
          autoplay: {
            delay: 0,  // 切换间隔时间（毫秒）
            disableOnInteraction: false,  // 用户操作后是否停止自动播放
          },
          speed: 4000,
          clickable: true,
          slidesPerView: t.isMobile ? 2 : 5,
          navigation: {
            nextEl: '.intel_next',
            prevEl: '.intel_prev',
          },
        })
        this.swiper2 = new Swiper('.honorswiper', {
          // pagination: {
          //   el: '.swiper-pagination-intellectual',
          //   clickable: true,
          // },
          loop: true, // 是否循环，内容会两倍
          autoplay: {
            delay: 0,  // 切换间隔时间（毫秒）
            disableOnInteraction: false,  // 用户操作后是否停止自动播放
          },
          speed: 4000,
          clickable: true,
          slidesPerView: t.isMobile ? 2 : 3,
          navigation: {
            nextEl: '.honor_next',
            prevEl: '.honor_prev',
          },
        })
      },
      changeIndex(cutId, step){
        let newIndex = cutId + step
        if(newIndex>this.timelist.length-1){
          newIndex = 0
        }else if(newIndex==-1){
          newIndex = this.timelist.length-1
        }
        this.currentYear = newIndex
        this.$refs.carousel.setActiveItem(newIndex);
      },
      goTo(index) {
        // 通过索引切换
        this.$refs.carousel.setActiveItem(index);
        this.currentYear = index
      },
    }
  }
</script>
  
  
  <style lang="less">
    .leaflet-bottom{
      opacity: 0;
      z-index: -1;
    }
    .el-input /deep/ .el-input__inner{
      border: none;
      height: 38px;
      line-height: 38px;
    }
    .el-textarea /deep/ .el-textarea__inner{
      border: none;
    }
    p{
      margin: 0;
    }
    .intelswiper{
      position: relative;
    }
    .honorswiper{
      position: relative;
    }
    .about{
      .word{
        .word-title{
          line-height: 44px;
          font-size: 32px;
          margin-top: 60px;
          font-weight: bold;
          text-align: center;
          color: #313E47;
        }
        .word-text{
          color: #313E47;
          font-size: 16px;
          line-height: 26px;
          font-weight: normal;
          text-align: center;
        }
      }
      .ability-box{
        max-width: 1400px;
        margin: 30px auto 50px;
        .gray-box{
          border-radius: 10px;
          background-color: #F3F3F5;
          padding: 30px 30px;
          height: 178px;
          box-sizing: border-box;
          .ability-tit{
            font-size: 18px;
            line-height: 50px;
            font-weight: bold;
            .blue-text{
              color: #10D2FE;
              font-size: 40px;
              font-weight: normal;
            }
          }
          .ability-text{
            color: #989898;
            font-size: 16px;
            line-height: 22px;
          }
        }
      }
      .tech-box{
        max-width: 1400px;
        margin: 40px auto;
        position: relative;
        .tech-title{
          font-size: 29px;
          line-height: 40px;
        }
        .tech-subtitle{
          font-size: 24px;
          color: #989898;
          line-height: 76px
        }
        .tech-detail{
          font-size: 16px;
          color: #989898;
          width: 64%;
          line-height: 34px;
          margin-top: 30px;
        }
        .tech-big{
          position: absolute;
          right: 0px;
          top: 8px;
          width: 33%;
        }
        .tech-one{
          // background-color: #F3F3F5;
          text-align: center;
          padding: 6% 18%;
          margin-top: 33px;
          .tech-one-img{
            width: 55px;
            height: 55px;
            margin: 14px auto 36px;
          }
          .tech-one-title{
            font-weight: bold;
            font-size: 18px;
            color: #000;
          }
          .tech-one-con{
            font-size: 14px;
            color: #989898;
            line-height: 22px;
            margin-top: 30px;
            height: 100px;
          }
        }
      }
      .content{
        margin: 50px auto 0;
        max-width: 1400px;
        .contentText{
          font-size: 15px;
          color: #515151;
          line-height: 27px;
          // text-align: justify;  首行缩进
          // text-indent: 32px;
          margin-right: 8px;
          .title{
            color: #000;
            font-size: 22px;
            line-height: 100px;
            font-weight: bold;
          }
          .content-p{
            color: #989898;
            margin: 20px 0;
            font-size: 16px;
            line-height: 34px;
          }
        }
        .contentlist{
          margin: 60px 0;
          .content-one{
            text-align: center;
            width: 54%;
            margin: 20px auto;
            .content-one-dec{
              color: #989898;
              font-size: 14px;
              line-height: 22px;
            }
            .content-one-num{
              font-size: 42px;
              line-height: 60px;
              color: #000;
            }
          }
        }
      }
      .middle-bg{
        max-width: min(1400px, 100%);
        margin: 0 auto;
        display: block;
      }
      .middle-text{
        .middle-text-tit{
          text-align: center;
          font-size: 32px;
          font-weight: bold;
          line-height: 100px;
          margin-top: 40px;
          margin-bottom: 14px;
          color: #1b1b1b;
        }
        .middle-text-con{
          text-align: center;
          font-size: 18px;
          color: #384C5C;
          max-width: 860px;
          margin: 0 auto;
          width: 100%;
          line-height: 34px;
        }
      }
      .mission{
        padding: 0px 0 0px;
        max-width: 1400px;
        margin: 0 auto;
        .word-title{
          line-height: 44px;
          font-size: 32px;
          font-weight: bold;
          color: #1b1b1b;
          font-family: fantasy;
          text-align: center;
        }
        .word-text{
          font-size: 17px;
          color: #534f4e ;
          line-height: 26px;
          margin-bottom: 40px;
          text-align: center;
        }
        .mission-content{
          max-width: 1400px;
          margin: 0 auto;
          .mission-one{
            background: linear-gradient(to bottom, #D1F7FF, #fff);
            text-align: center;
            padding: 75px 0 50px 0;
            margin-bottom: 20px;
            position: relative;
            .one-sort{
              font-size: 28px;
              color: #00D0FF;
              position: absolute;
              left: -10px;
              top: 50px;
              font-weight: bold;
            }
            .one-title{
              color: #384C5C;
              font-weight: bold;
              font-family: auto;
              font-size: 50px;
            }
            .one-title-cn{
              color: #384C5C;
              font-size: 20px;
              line-height: 60px;
            }
            .one-text{
              color: #989898;
              font-size: 16px;
            }
          }
          .mission-one-left{
            margin-right: 20px;
          }
          .mission-blue{
            background: #0177ff;
            width: 100%;
            height: 267px;
            background-image: url('../../assets/icon/ULTU.png');
            background-repeat: no-repeat;
            background-position: right;
          }
        }
        
      }
      .develop{
        background-color: #F3F3F5;
        padding: 2px 0 20px;
        .timelist{
          max-width: 1000px;
          margin: 50px auto 20px;
          cursor: pointer;
          -webkit-user-select: none; /* Safari/Chrome */
          -moz-user-select: none;    /* Firefox */
          -ms-user-select: none;     /* IE/Edge */
          user-select: none;
          .timelist-year-one{
            position: relative;
            cursor: pointer;
            .timelist-text{
              line-height: 50px;
              position: relative;
            }
            .timelist-year{
              color: #989898;
              font-size: 20px;
              display: inline-block;
              vertical-align: middle;
            }
            .blueFont{
              color: #00D0FF;
            }
            .timelist-bot{
              // width: 8px;
              // height: 8px;
              border-radius: 50%;
              background-color: #00D0FF;
              margin-left: 20px;
              display: inline-block;
              vertical-align: middle;
            }
            .timelist-blueBot-big{
              width: 6px;
              height: 40px;
              margin-left: 16px;
              border-radius: 0;
            }
            .timelist-line{
              width: 1px;
              height: 50px;
              background-color: #e0e0e0;
              position: absolute;
              left: 85px;
              z-index: 0;
            }
          }

          .timelist-content{
            margin: 10px 0 0;
            cursor: pointer;
            .timelist-content-one{
              line-height: 40px;
              color: #384C5C;
              .idot{
                width: 6px;
                height: 6px;
                display: inline-block;
                background-color: #384C5C;
                border-radius: 50%;
                margin-right: 10px;
              }
            }
            .timelist-content-year{
              position: absolute;
              bottom: 0;
              right: 0;
              opacity: 0.4;
            }
          }
          .el-carousel__indicators--vertical{
            right: 0;
            left: none;
          }
        }
      }
      .intellectual{
        // padding: 60px 0 0;
        .intellectual-content{
          padding: 40px 0 0;
          max-width: 1400px;
          margin: 0 auto;
          .bannerList{
            max-width: 1400px;
            margin: 0 auto;
            overflow: hidden;
            border: 1px solid #f7f7f7;
            border-radius: 20px;
            .intel_prev,.intel_next,.honor_prev,.honor_next{
              background-color: #00D0FF;
              color: #fff;
            }
            .intel_prev:after,.intel_next:after,.honor_prev:after,.honor_next:after{
              font-size: 12px;
            }
            .intel_prev,.honor_prev{
              left: 0px;
            }
            .intel_next,.honor_next{
              right: 0px;
            }
          }

          .swipperItem{
            position: relative;
            text-align: left;
            padding: 10% 12%;
            cursor: default;
            .imgBox{
              border: 1px solid #a3a2a0;
              padding: 4px 6px;
              background: #fff;
              margin: 40px 0 0;
            }
            .honor-img{
              width: 100%;
              height: 218px;
            }
            .img-up-word{
              .img-up-word-content{
            //     margin: 203px 10px 0;
                font-size: 14px;
            //     text-align: right;
            //   }
            //   .img-up-word-dec{
            //     font-size: 14px;
            //     margin: 0 10px;
              }
            }
          }
          .swiper-pagination-intellectual{
            margin: 20px 0;
            text-align: center;
          }
          .swiper-pagination-honor{
            margin: 20px 0;
            text-align: center;
          }
          .intellectual-list{
            .intellectual-one{
              text-align: center;
              display: inline-block;
              width: 14%;
              .word{
                display: inline-block;
                .intellectual-word-big{
                  color: #171717;
                  font-size: 34px;
                  font-weight: bold;
                }
                .intellectual-word-small{
                  color: #161616;
                  font-size: 16px;
                }
                .intellectual-word-text{
                  color: #161616;
                  font-size: 16px;
                }
              }
              .gray{
                background: #d7d3d4;
                width: 2px;
                height: 48px;
                float: right;
                margin-top: 12px;
              }
            }
          }
        }
      }
      .intel-box{
        max-width: 1400px;
        margin: 20px auto 80px;
        background: url("./../../assets/honor/cup.png")no-repeat 50% 20%;
        .intel-one{
          text-align: center;
          margin: 100px 0;
          .intel-one-num{
            color: #989898;
            font-size: 50px;
            line-height: 70px;
          }
          .intel-one-unit{
            color: #989898 ;
            font-size: 20px;
          }
          .intel-one-text{
            font-size: 20px;
            font-weight: bold;
          }
        }
      }
      .cooperation{
        max-width: min(1200px, 86%);
        margin: 0px auto;
        overflow: hidden;
        .swipperOne{
          margin: 20px 4px;
          // height: 290px;
          .swipperItem{
            box-sizing: border-box;
            background: url(../../assets/partner/bg.png) no-repeat 0px 0px;
            background-size: 100% 100%;
            height: 0;
            padding-top: 125%;
            aspect-ratio: 232/290;
            position: relative;
            display: flex;
            align-items: center;
            .coo-img{
              width: 76%;
              position: absolute;
              top: 43%;
              left: 50%;
              transform: translate(-50%, -50%);
            }
          }
        }
      }
      .cooperation2{
        max-width: min(1400px, 100%);
        margin: -8.4% auto 0;
        overflow: hidden;
        .swipperOne{
          margin: 20px 4px;
          // height: 290px;
          .swipperItem{
            box-sizing: border-box;
            background: url("./../../assets/partner/bg.png") no-repeat 0px 0px;
            background-size: 100% 100%;
            padding-top: 125%;
            aspect-ratio: 232/290;
            position: relative;
            display: flex;
            align-items: center;
            .coo-img{
              width: 76%;
              position: absolute;
              top: 43%;
              left: 50%;
              transform: translate(-50%, -50%);
            }
          }
        }
      }
      .cooperation3{
        margin: -8% auto 0;
      }
    }
    .about-m{
      .word{
        .word-title{
          text-align: center;
          padding: 0.8rem 0 0;
          line-height: 1.2rem;
          font-size: 0.6rem;
          font-weight: 500;
        }
        .word-text{
          text-align: center;
          color: #9b9b9b;
          font-size: 0.4rem;  
        }
      }
      .content{
        margin: 0.4rem auto;
        .contentText{
          width: 90%;
          margin: 0.3rem auto;
          font-size: 0.3rem;
          color: #515151;
          line-height: 0.6rem;
          .title{
            color: #4e6486;
            font-size: 0.5rem;
            line-height: 1.06rem;
          }
          .content-p{
            color: #989898;
            line-height: 0.54rem;
            margin: 0.2rem 0;
            font-size: 0.36rem;
          }
        }
        .contentlist{
          margin: 0;
          .content-one{
            text-align: center;
            width: 80%;
            margin: 0.4rem auto;
            .content-one-dec{
              color: #989898;
              font-size: 0.28rem;
              line-height: 0.44rem;
            }
            .content-one-num{
              font-size: 0.7rem;
              line-height: 1.2rem;
              color: #000;
            }
          }
        }
      }
      .ability-box{
        max-width: 90%;
        margin: 0.6rem auto;
        .gray-box{
          border-radius: 0.2rem;
          background-color: #F3F3F5;
          padding: 0.3rem 0.4rem;
          margin: 0.1rem 0;
          height: 3.2rem;
          box-sizing: border-box;
          .ability-tit{
            font-size: 0.36rem;
            line-height: 1rem;
            font-weight: bold;
            .blue-text{
              color: #10D2FE;
              font-size: 0.8rem;
              font-weight: normal;
            }
          }
          .ability-text{
            color: #989898;
            font-size: 0.32rem;
            line-height: 0.44rem;
          }
        }
      }
      .tech-box{
        max-width: 90%;
        margin: 0.8rem auto;
        position: relative;
        .tech-title{
          font-size: 0.44rem;
          line-height: 0.8rem;
        }
        .tech-subtitle{
          font-size: 0.4rem;
          color: #989898;
        }
        .tech-detail{
          font-size: 0.36rem;
          color: #989898;
          line-height: 0.54rem;
          margin-top: 0.4rem;
        }
        .tech-big{
          width: 100%;
          margin-top: 0.4rem;
        }
        .tech-one{
          background-color: #F3F3F5;
          text-align: center;
          padding: 0.4rem;
          margin-top: 0.2rem;
          .tech-one-img{
            width: 1.1rem;
            height: 1.1rem;
            margin: 0.6rem auto 0.4rem;
          }
          .tech-one-title{
            font-weight: bold;
            font-size: 0.36rem;
            color: #000;
          }
          .tech-one-con{
            font-size: 0.30rem;
            color: #989898;
            text-align: left;
            line-height: 0.4rem;
            margin-top: 0.4rem;
            height: 2rem;
          }
        }
      }
      .middle-text{
        width: 90%;
        margin: 0 auto;
        text-align: center;
        .middle-text-tit{
          font-size: 0.5rem;
          line-height: 1.6rem;
          font-weight: bold;
          margin-top: 0.56rem;
        }
        .middle-text-con{
          font-size: 0.36rem;
          line-height: 0.56rem;
        }
      }
      .middle-bg{
        width: 100%;
      }
      .mission{
        padding: 0 0 0.4rem;
        .word-big{
          text-align: center;
          padding: 0.8rem 0 0;
          line-height: 1.2rem;
          font-size: 0.6rem;
          font-weight: 500;
        }
        .word-small{
          text-align: center;
          padding: 0.8rem 0 0;
          color: #9b9b9b;
          font-size: 0.4rem;
        }
        .mission-content{
          margin: 0.8rem 0.2rem 0;
          .mission-one{
            background: #f3f3f3;
            position: relative;
            text-align: left;
            padding: 0.8rem 1rem 0.8rem 1rem;
            margin-bottom: 0.5rem;
            border-radius: 0.4rem;
            .one-title{
              color: #384C5C;
              font-weight: bold;
              font-family: auto;
              font-size: 0.4rem;
            }
            .one-title-cn{
              color: #384C5C;
              font-size: 0.46rem;
              margin: 0.4rem 0 0.18rem;
              font-weight: bold;
            }
            .one-text{
              color: #404143;
              font-size: 0.4rem;
              line-height: 0.7rem;
            }
          }
        }
        
      }
      .develop{
        font-size: 0.3rem;
        width: 100%;
        margin: 0 auto 0.6rem;
        .timelist{
          max-width: 90%;
          margin: 1rem auto 0.4rem;
          cursor: pointer;
          -webkit-user-select: none; /* Safari/Chrome */
          -moz-user-select: none;    /* Firefox */
          -ms-user-select: none;     /* IE/Edge */
          user-select: none;
          .timelist-year-one{
            position: relative;
            cursor: pointer;
            .timelist-text{
              margin-bottom: 0.3rem;
              position: relative;
            }
            .timelist-year{
              color: #989898;
              font-size: 0.4rem;
              display: inline-block;
              vertical-align: middle;
            }
            .blueFont{
              color: #00D0FF;
            }
            .timelist-bot{
              width: 0.16rem;
              height: 0.16rem;
              border-radius: 50%;
              background-color: #00D0FF;
              margin-left: 0.4rem;
              display: inline-block;
              vertical-align: middle;
            }
            .timelist-blueBot-big{
              width: 0.32rem;
              height: 0.32rem;
              margin-left: 0.32rem;
            }
            .timelist-line{
              width: 0.04rem;
              height: 0.7rem;
              background-color: #e0e0e0;
              position: absolute;
              left: 1.74rem;
              top: 0.36rem;
              z-index: 0;
            }
          }

          .timelist-content{
            margin: 0 0;
            cursor: pointer;
            .timelist-content-one{
              line-height: 0.6rem;
              color: #384C5C;
              font-size: 0.32rem;
              .idot{
                width: 0.12rem;
                height: 0.12rem;
                display: inline-block;
                background-color: #384C5C;
                border-radius: 50%;
                margin-right: 0.2rem;
              }
            }
            .timelist-content-year{
              position: absolute;
              bottom: 0;
              right: 0;
              width: 4rem;
              opacity: 0.4;
            }
          }
          .el-carousel__indicators--vertical{
            right: 0;
            left: none;
          }
        }
      }
      .intel-box{
        width: 90%;
        margin: 0 auto;
        background: url("./../../assets/honor/cup.png")no-repeat 50% 20%;
        background-size: 90% 80%;
        .intel-one{
          text-align: center;
          margin: 1.2rem 0;
          .intel-one-num{
            color: #989898;
            font-size: 1rem;
            line-height: 1.4rem;
          }
          .intel-one-unit{
            color: #989898 ;
            font-size: 0.4rem;
          }
          .intel-one-text{
            font-size: 0.4rem;
            font-weight: bold;
          }
        }
      }
      .intellectual{
        padding: 0 0 0;
        .intellectual-content{
          padding: 0.4rem 0 0.5rem;
          max-width: 90%;
          margin: 0 auto;
          .bannerList{
            max-width: 100%;
            margin: 0 auto;
            // overflow: hidden;
            border: 0.01rem solid #f7f7f7;
            border-radius: 0.4rem;
            .intel_prev,.intel_next,.honor_prev,.honor_next{
              background-color: #00D0FF;
              color: #fff;
            }
            .intel_prev:after,.intel_next:after,.honor_prev:after,.honor_next:after{
              font-size: 0.24rem;
            }
            .intel_prev,.honor_prev{
              left: 0;
            }
            .intel_next,.honor_next{
              right: 0;
            }
          }

          .swipperItem{
            position: relative;
            text-align: left;
            padding: 10% 12%;
            cursor: default;
            .imgBox{
              border: 0.01rem solid #a3a2a0;
              padding: 0.08rem 0.12rem;
              background: #fff;
              margin: 0.8rem 0 0;
            }
            .honor-img{
              width: 100%;
              height: 4rem;
            }
            .img-up-word{
              .img-up-word-content{
                font-size: 0.28rem;
              }
            }
          }
          .swiper-pagination-intellectual{
            margin: 0.4rem 0;
            text-align: center;
          }
          .swiper-pagination-honor{
            margin: 0.4rem 0;
            text-align: center;
          }
          .intellectual-list{
            .intellectual-one{
              text-align: center;
              display: inline-block;
              width: 14%;
              .word{
                display: inline-block;
                .intellectual-word-big{
                  color: #171717;
                  font-size: 0.6rem;
                  font-weight: bold;
                }
                .intellectual-word-small{
                  color: #161616;
                  font-size: 0.32rem;
                }
                .intellectual-word-text{
                  color: #161616;
                  font-size: 0.32rem;
                }
              }
              .gray{
                background: #d7d3d4;
                width: 0.04rem;
                height: 1rem;
                float: right;
                margin-top: 0.24rem;
              }
            }
          }
        }
      }
      .cooperation{
        max-width: 72%;
        margin: 0.2rem auto;
        overflow: hidden;
        .swipperOne{
          margin: 0.1rem 0.08rem;
          height: 2.6rem;
          .swipperItem{
            box-sizing: border-box;
            background: url(../../assets/partner/bg.png) no-repeat 0px 0px;
            background-size: 100% 100%;
            height: 100%;
            position: relative;
            display: flex;
            align-items: center;
            .coo-img{
              width: 70%;
              position: absolute;
              left: 50%;
              margin-left: -35%;
              margin-top: -0.3rem;
            }
          }
        }
      }
      .cooswiper01{
        margin-top: 0.6rem;
      }
      .cooperation2{
        max-width: 96%;
        margin: -1rem auto 0;
        overflow: hidden;
        .swipperOne{
          margin: 0.1rem 0.08rem;
          height: 2.6rem;
          .swipperItem{
            box-sizing: border-box;
            background: url(http://127.0.0.1:8080/img/bg.abd83cd7.png) no-repeat 0px 0px;
            background-size: 100% 100%;
            height: 100%;
            position: relative;
            display: flex;
            align-items: center;
            .coo-img{
              width: 76%;
              position: absolute;
              left: 50%;
              margin-left: -38%;
              margin-top: -0.3rem;
            }
          }
        }
      }
      .cooperation3{
        margin: -0.8rem auto 0;
      }
    }
  </style>